// ─────────────────────────────────────────────
//  ModeSegment.jsx — Descontar / Agregar
// ─────────────────────────────────────────────

import React from 'react';
import styles from './ModeSegment.module.css';

const MODES = [
	{ id: 'discount', label: 'Descontar', icon: '−' },
	{ id: 'add',      label: 'Agregar',  icon: '+' },
];

export default function ModeSegment({ mode, onChange }) {
	return (
		<div
			className={styles.segment}
			role="radiogroup"
			aria-label="Tipo de cálculo"
		>
			{MODES.map(({ id, label, icon }) => {
				const isActive = mode === id;
				return (
					<button
						key={id}
						type="button"
						className={`${styles.option} ${isActive ? styles.optionActive : ''}`}
						role="radio"
						aria-checked={isActive}
						onClick={() => onChange(id)}
					>
						<span className={styles.icon} aria-hidden="true">{icon}</span>
						{label}
					</button>
				);
			})}
		</div>
	);
}
